<template>
  <div class="catalog-form users-admin-form">
    <h1>
      <i class="fal fa-arrow-circle-left" @click="onCancel" title="Regresar"></i>
      <span>{{ title }}</span>

      <div class="top-tool-bar flat actions">
        <div class="action" v-if="id" @click="init"><i class="fal fa-sync"></i> Refrescar</div>
        <div class="action" v-if="editButton" @click="onEdit"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action" v-if="!readOnly && id && form.status !== 'inactive' && deleteButton" @click="inactiveUser"><i class="fal fa-power-off"></i> Baja</div>
        <div class="action" v-if="!readOnly && id && form.status === 'active' && resetPasswordButton" @click="resetPass"><i class="fal fa-key"></i> Reset password</div>
      </div>
    </h1>

    <div class="menu-area hide-md">
      <div class="list-group">
        <a href="#init" class="list-group-item list-group-item-action" aria-current="true" v-if="id">
          Actualizaciones
        </a>
        <a href="#general" class="list-group-item list-group-item-action" aria-current="true">
          Información general
        </a>
        <a href="#admin" class="list-group-item list-group-item-action" aria-current="true" v-if="isBmAdminWithPermission">
          Datos administrativos
        </a>
        <a href="#groups" class="list-group-item list-group-item-action" aria-current="true">
          Grupos del usuario
        </a>
      </div>
    </div>

    <div class="form-area">
      <b-form @submit.stop.prevent="onSubmit" v-show="!loading">
        <b-card id="init" header="Actualizaciones" class="form-section" v-if="id">
          <table class="table table-responsive-md">
            <thead>
              <tr>
                <th scope="col">Evento</th>
                <th scope="col">Usuario</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Creación</td>
                <td>{{ form.creationUser && form.creationUser.name || '--' }}</td>
                <td>{{ creationDate }}</td>
              </tr>
              <tr>
                <td>Actualización</td>
                <td>{{ form.updateUser && form.updateUser.name || '--' }}</td>
                <td>{{ updateDate || '--' }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>

        <!-- INFORMACION GENERAL -->
        <b-card id="general" header="Información general" class="form-section">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group
                id="input-group-domain"
                label="Dominio *"
                label-for="input-domain"
                style="position: relative">
                <b-form-input
                  id="input-domain"
                  name="input-domain"
                  type="text"
                  class="shadow-none"
                  placeholder="Seleccione el dominio"
                  v-model.trim="searchDomain"
                  :maxlength="255"
                  autocomplete="off"
                  @click="showDomainSelection(true)"
                  @focus="showDomainSelection(true)"
                  @blur="showDomainSelection(false)"
                  :disabled="readOnly || !isBmAdminWithPermission">
                </b-form-input>
                <div class="dropdown-input-selection-list" v-if="domainSelectionOpen">
                  <table class="table">
                    <tbody>
                      <tr v-for="it in domains" :key="it.id" @click="selectDomain(it)" v-show="isMatchDomain(it)">
                        <td>{{ it.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm-12">
              <b-form-group
                id="input-group-client"
                label="Cliente *"
                label-for="input-client"
                style="position: relative">
                <b-form-input
                  id="input-client"
                  name="input-client"
                  type="text"
                  class="shadow-none"
                  :placeholder="loadingClients || loadingRoles ? 'Cargando clientes...' : (clients.length ? 'Seleccione el cliente' : 'No se encontraron clientes para el dominio')"
                  v-model.trim="searchClient"
                  :maxlength="255"
                  autocomplete="off"
                  @click="showClientSelection(true)"
                  @focus="showClientSelection(true)"
                  @blur="showClientSelection(false)"
                  :state="validateClient"
                  aria-describedby="input-client-feedback"
                  :disabled="readOnly || !clients.length || loadingClients || !isBmAdminWithPermission">
                </b-form-input>
                <b-form-invalid-feedback id="input-client-feedback">El cliente es necesario</b-form-invalid-feedback>
                <div class="dropdown-input-selection-list" v-if="clientSelectionOpen">
                  <table class="table">
                    <tbody>
                      <tr v-for="it in clients" :key="it.id" @click="selectClient(it)" v-show="isMatchClient(it)">
                        <td>{{ it.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm-12">
              <b-form-group
                id="input-group-role"
                label="Rol *"
                label-for="input-role"
                style="position: relative">
                <b-form-input
                  id="input-role"
                  name="input-role"
                  type="text"
                  class="shadow-none"
                  :placeholder="loadingClients || loadingRoles ? 'Cargando roles...' : (roles.length ? 'Seleccione un rol para el usuario' : 'No se encontraron roles para el dominio')"
                  v-model.trim="searchRole"
                  :maxlength="255"
                  autocomplete="off"
                  @click="showRoleSelection(true)"
                  @focus="showRoleSelection(true)"
                  @blur="showRoleSelection(false)"
                  :disabled="readOnly || !roles.length || loadingRoles">
                </b-form-input>
                <div class="dropdown-input-selection-list" v-if="roleSelectionOpen">
                  <table class="table">
                    <tbody>
                      <tr v-for="it in roles" :key="it.id" @click="selectRole(it)" v-show="isMatchRole(it)">
                        <td>{{ it.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-name"
                label="Nombre de usuario*"
                label-for="input-name">
                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  class="shadow-none"
                  placeholder="Nombre sin espacios. Ej. bmuser, bmuser01, bmuser_01"
                  v-model.trim="form.name"
                  :maxlength="50"
                  v-validate="{ required: true, regex: regexUsername }"
                  :state="validateState('input-name')"
                  aria-describedby="input-name-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-name-feedback">
                  Ingrese un nombre de usuario válido, este puede contener únicamente valores alfanuméricos y guiones (_,-)
                  con un mínimo de longitud de tres caracteres.
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-email"
                label="Correo electrónico *"
                label-for="input-email">
                <b-form-input
                  id="input-email"
                  name="input-email"
                  type="email"
                  class="shadow-none"
                  placeholder="Correo electrónico del usuario"
                  v-model.trim="form.email"
                  :maxlength="255"
                  v-validate="{ required: true, email: true }"
                  :state="validateState('input-email')"
                  aria-describedby="input-email-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-email-feedback">Introduzca un correo válido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-fname"
                label="Nombre de la persona"
                label-for="input-fname">
                <b-form-input
                  id="input-fname"
                  name="input-fname"
                  type="text"
                  class="shadow-none"
                  placeholder="Nombre de la persona"
                  v-model.trim="form.firstName"
                  :maxlength="50"
                  :state="validateState('input-fname')"
                  aria-describedby="input-fname-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-fname-feedback">El nombre es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-lname"
                label="Apellido(s)"
                label-for="input-lname">
                <b-form-input
                  id="input-lname"
                  name="input-lname"
                  type="text"
                  class="shadow-none"
                  placeholder="Apellido(s) de la persona"
                  v-model.trim="form.lastName"
                  :maxlength="50"
                  :state="validateState('input-lname')"
                  aria-describedby="input-lname-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-lname-feedback">El apellido es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group id="input-group-phone-code" label="Código de país">
                <b-form-select
                  id="input-select-phone-code"
                  name="input-select-phone-code"
                  class="shadow-none"
                  v-model="form.cellPhone.countryCode"
                  :options="phoneCodes"
                  :state="validateState('input-select-phone-code')"
                  aria-describedby="input-select-phone-code-feedback"
                  @change="onCountryCodeChange"
                  :disabled="readOnly">
                </b-form-select>
                <div class="country-flag" v-if="selectedCountryIso">
                  <img :src="`https://flagcdn.com/${selectedCountryIso}.svg`" width="32">
                </div>
                <b-form-invalid-feedback id="input-select-phone-code-feedback">El código de país es requerido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-phone"
                label="Teléfono"
                label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  name="input-phone"
                  type="text"
                  class="shadow-none"
                  placeholder="Ej. 5537081925"
                  v-model.trim="form.cellPhone.number"
                  :maxlength="16"
                  v-validate="{ regex: regexPhone }"
                  :state="validateState('input-phone')"
                  aria-describedby="input-phone-feedback"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-phone-feedback">Introduzca un teléfono válido (Ej: 5512345678) </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-email-extra"
                label="Correo electrónico extra"
                label-for="input-email-extra">
                <b-form-input
                  id="input-email-extra"
                  name="input-email-extra"
                  type="email"
                  class="shadow-none"
                  placeholder="Correo electrónico extra del usuario"
                  v-model.trim="form.emailExtra"
                  :maxlength="255"
                  v-validate="{ email: true }"
                  :state="validateState('input-email-extra')"
                  aria-describedby="input-email-feedback-extra"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-email-feedback-extra">Introduzca un correo válido</b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-sm-12 col-md-6">
              <b-form-group
                id="input-group-phone-extra"
                label="Teléfono extra"
                label-for="input-phone-extra">
                <b-form-input
                  id="input-phone-extra"
                  name="input-phone-extra"
                  type="text"
                  class="shadow-none"
                  placeholder="Ej. 5537081925"
                  v-model.trim="form.phoneExtra"
                  :maxlength="16"
                  v-validate="{ regex: regexPhone }"
                  :state="validateState('input-phone-extra')"
                  aria-describedby="input-phone-feedback-extra"
                  :disabled="readOnly">
                </b-form-input>
                <b-form-invalid-feedback id="input-phone-feedback-extra">Introduzca un teléfono válido (Ej: +525512345678 ó 5512345678)</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-12">
              <b-form-group
                id="external-id"
                :label="$t('users.columns.externalId.label')"
                label-for="input-external-id">
                <b-form-input
                  id="input-external-id"
                  name="input-external-id"
                  type="text"
                  class="shadow-none"
                  :placeholder="$t('users.columns.externalId.placeholder')"
                  v-model.trim="form.externalId"
                  :maxlength="255"
                  :disabled="readOnly">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- DATOS ADMINISTRATIVOS -->
        <b-card id="admin" header="Datos administrativos" class="form-section" v-if="isBmAdminWithPermission">
          <div class="row">
            <div class="col-sm-12">
              <b-form-group label="Estado">
                <b-form-input
                  type="text"
                  class="shadow-none"
                  :value="getStatusText()"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-12" v-if="form.disableDate">
              <b-form-group label="Fecha de baja">
                <b-form-input
                  type="text"
                  class="shadow-none"
                  :value="disableDate"
                  :disabled="true">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="col-sm-12">
              <b-form-group>
                <b-form-checkbox v-model="form.billable" :disabled="readOnly">Licencia facturable</b-form-checkbox>
              </b-form-group>
            </div>

            <div class="col-sm-12">
              <b-form-group>
                <b-form-checkbox v-model="form.extendedPermissions" :disabled="readOnly">Permisos extendidos</b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </b-card>

        <!-- GRUPO -->
        <b-card id="groups" header="Grupos a los que pertenece el usuario" class="form-section users-groups">
          <div v-if="groups.length">
            <AdminGroupSelectionTreeItem v-for="it in groups" :key="it.id"
              :group="it" :root="true" :watchActive="watchGroupsTreeActive" :readOnly="readOnly"
              @update-group="updateGroupsSelected"/>
          </div>
          <div v-else>Sin grupos para seleccionar</div>
        </b-card>

        <!-- ACCIONES -->
        <div class="text-right">
          <b-button class="mr-2" size="lg" @click="onCancel">Cancelar</b-button>
          <b-button type="submit" variant="primary" size="lg" v-if="!readOnly">Guardar usuario</b-button>
        </div>
      </b-form>

      <LoadingMask :active="loading"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Client, User, BasicEntity, UserStatus, ClientWorkspacesFilters, Workspace, Group, Role, RoleCatalogFilters, BLUEMESSAGING_ID } from '@/types/Catalogs'
import DateSelector from '@/components/generic/DateSelector.vue'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import AdminGroupSelectionTreeItem from '@/components/admin/AdminGroupSelectionTreeItem.vue'
import catalogsService from '@/services/CatalogsService'
import { ADMIN_ROLES, RoleNames } from '@/types/Auth'
import userInfoStore from '@/store/userInfo'
import { PageRequest } from '@/types/Support'
import phoneCodes from '@/data/phoneCodes'
import messageService from '@/services/support/MessageService'
import { MessageError } from '../generic/MessageHandling.vue'
import { GroupCatalogFilters, GroupStatus } from '@/types/catalogs/Groups'
import DateFormat from '@/services/DateFormat'
import { GENERAL_REGEXPS } from '@/types/RegExpressions' // eslint-disable-line no-unused-vars

@Component({
  components: {
    DateSelector,
    LoadingMask,
    AdminGroupSelectionTreeItem
  }
})
export default class AdminUserForm extends Vue {
  @Prop({ required: true, default: 0 })
  id: number

  @Prop({ required: true, default: '' })
  title: string

  @Prop({ required: false, default: false })
  readOnly: boolean

  @Prop({ required: false, default: false })
  editButton: boolean

  @Prop({ required: false, default: false })
  deleteButton: boolean

  @Prop({ required: false, default: false })
  resetPasswordButton: boolean

  @Prop({ required: true, default: [] })
  domains: BasicEntity[]

  clients: Client[] = []
  groups: Group[] = []
  roles: Role[] = []

  phoneCodes: any[] = []

  loading = false
  loadingClients = false
  loadingRoles = false

  form: User = User.getIntanceForEdit()

  statusOptions: any[] = []

  regexUsername = /^[0-9a-zA-Z_-]{3,50}$/
  regexPhone = GENERAL_REGEXPS.phone

  creationDate = ''
  updateDate = ''
  disableDate = ''

  domainSelectionOpen = false
  domainSelected: any = {}
  domainSelectedBackup: any = {}
  searchDomain = ''

  clientSelectionOpen = false
  clientSelected: any = {}
  clientSelectedBackup: any = {}
  searchClient = ''

  roleSelectionOpen = false
  roleSelected: any = {}
  roleSelectedBackup: any = {}
  searchRole = ''

  countryFlag = ''
  selectedCountryIso = ''

  watchGroupsTreeActive = false
  BMAdminWithPermissionRoles: RoleNames[] = [
    RoleNames.OPERATIONS_ADMIN,
    RoleNames.SUPPORT
  ]

  created () {
    this.phoneCodes = [{ value: null, text: '-- Seleccione código de país --', iso: '' }].concat(
      phoneCodes.reduce((arr: any[], it: any) => arr.concat({ value: `+${it.phone_code}`, text: `${it.nombre} (+${it.phone_code})`, iso: it.iso2.toLowerCase() }), [])
    ) as any
  }

  mounted () {
    this.init()
  }

  init () {
    if (this.id) {
      this.loading = true
      catalogsService.getUserById(this.id).then(async (data: User) => {
        this.creationDate = data.creationDate ? new DateFormat(data.creationDate).toDateTimeString() : '- - / - - / - - - -'
        this.updateDate = data.updateDate ? new DateFormat(data.updateDate).toDateTimeString() : '- - / - - / - - - -'
        this.disableDate = data.disableDate ? new DateFormat(data.disableDate).toDateTimeString() : '- - / - - / - - - -'
        if (!data.cellPhone) {
          data.cellPhone = { countryCode: null as any, number: null as any }
        }
        this.form = data

        this.initValues()

        this.$validator.reset()
      })
        .catch((error) => {
          let messageValues = {
            title: 'Error en la carga de usuarios',
            message: '',
            delay: 4000,
            error: error
          }
          new MessageError({ propsData: messageValues }).displayMessage()
          this.onCancel()
        })
        .finally(() => {
          this.loading = false
        })
    } else {
      const domainOfLogged = this.domains.find(it => it.id === userInfoStore.userInfo.domain.id) as BasicEntity
      this.selectDomain(domainOfLogged || { id: userInfoStore.userInfo.domain.id, name: userInfoStore.userInfo.domain.name })
      this.watchGroupsTreeActive = true
    }
  }

  async initValues () {
    if (this.form.domain) {
      const domain = this.domains.find(it => it.id === this.form.domain.id) as any
      await this.selectDomain(domain || this.form.domain)

      if (this.form.groups) {
        const selectedIds = this.form.groups.reduce((arr: number[], it: BasicEntity) => arr.concat(it.id), [])
        this.setGroupsSelected(this.groups, selectedIds)
        setTimeout(() => {
          this.watchGroupsTreeActive = true
        }, 500)
      }
    }

    if (!this.readOnly) {
      if (this.form.client) {
        const client = this.clients.find(it => it.id === this.form.client.id)
        setTimeout(() => {
          this.selectClient(client)
        }, 500)
      }

      if (this.form.role) {
        const role = this.roles.find(it => it.id === this.form.role.id)
        setTimeout(() => {
          this.selectRole(role)
        }, 500)
      }
    }

    if (this.form.cellPhone) {
      this.onCountryCodeChange(this.form.cellPhone.countryCode)
    }
  }

  /* User permissions */

  get isBmAdminWithPermission () {
    return this.isRootDomainUser && this.BMAdminWithPermissionRoles.includes(userInfoStore.userInfo.role.name)
  }

  get isClientWithPermission () {
    return userInfoStore.userInfo.role.name === RoleNames.CLIENT_GENERIC_ADMIN || userInfoStore.userInfo.role.name === RoleNames.CLIENT_OWNER
  }

  /** Checks if the user belongs to root domain */
  get isRootDomainUser () {
    return userInfoStore.inRootDomain()
  }

  getStatusText () {
    if (this.form.id) {
      switch (this.form.status) {
        case 'active':
          return 'Activo'
        case 'inactive':
          return 'Baja'
        case 'suspended':
          return 'Suspendido'
        case 'updatePassword':
          return 'Contraseña restablecida'
      }
    } else {
      return 'Activo'
    }
  }

  showDomainSelection (flag: boolean) {
    if (!this.isBmAdminWithPermission) return
    if (flag) {
      this.searchDomain = ''
      this.domainSelected = {}
      this.domainSelectionOpen = true
    } else {
      setTimeout(() => {
        this.domainSelectionOpen = false
        if (this.domainSelectedBackup.name && this.domainSelectedBackup.id !== this.domainSelected.id) {
          this.searchDomain = this.domainSelectedBackup.name
          this.domainSelected = this.domainSelectedBackup
        }
      }, 200)
    }
  }

  async selectDomain (domain: BasicEntity) {
    this.domainSelected = domain
    this.domainSelectedBackup = domain
    this.searchDomain = domain.name
    await this.loadGroupsByDomain(domain.id)
    if (this.readOnly) {
      if (this.form.client) {
        this.selectClient(this.form.client)
      }
      if (this.form.role) {
        this.selectRole(this.form.role)
      }
    } else {
      await this.getClientsBySelectedDomain()
      await this.getRolesBySelectedDomain()
    }
  }

  isMatchDomain (domain: any) {
    if (!this.searchDomain) return true
    const regexSearch = new RegExp(this.searchDomain, 'i')
    return regexSearch.test(domain.name)
  }

  async getClientsBySelectedDomain () {
    this.loadingClients = true
    this.clients = []
    this.clientSelected = this.clientSelectedBackup = {}
    this.searchClient = ''
    const pageRequest = new PageRequest<ClientWorkspacesFilters>()
    pageRequest.filters.domainId = this.domainSelected.id
    const response = await catalogsService.getWorkspacesByDomain(pageRequest)

    this.clients.push(...response.results.map((it: Workspace) => {
      return { id: it.client.id, code: it.client.clientCode, name: it.client.name, status: it.status } as any
    }))

    let clientToSelect: any = this.clients
      .find((it) =>
        userInfoStore.userInfo.client
          ? it.id === userInfoStore.userInfo.client.id
          : it.id === BLUEMESSAGING_ID)

    setTimeout(() => {
      this.loadingClients = false
      if (clientToSelect) {
        this.selectClient(clientToSelect)
      }
    }, 350)
  }

  showClientSelection (flag: boolean) {
    if (flag) {
      this.searchClient = ''
      this.clientSelected = {}
      this.clientSelectionOpen = true
    } else {
      setTimeout(() => {
        this.clientSelectionOpen = false
        if (this.clientSelectedBackup.code) {
          this.selectClient(this.clientSelectedBackup)
        }
      }, 200)
    }
  }

  selectClient (client: any) {
    this.clientSelected = client
    this.clientSelectedBackup = client
    this.searchClient = client.name
  }

  isMatchClient (client: any) {
    if (client.status !== UserStatus.ACTIVE) return false
    if (!this.searchClient) return true
    const regexSearch = new RegExp(this.searchClient, 'i')
    return regexSearch.test(client.name)
  }

  async getRolesBySelectedDomain () {
    this.loadingRoles = true
    this.roles = []
    this.roleSelected = this.roleSelectedBackup = {}
    this.searchRole = ''
    const pageRequest = new PageRequest<RoleCatalogFilters>()
    pageRequest.filters.domain = this.domainSelected.id
    const response = await catalogsService.getRoles(pageRequest)
    for (const role of response.results) {
      if (this.isRootDomainUser || !ADMIN_ROLES.includes(role.name as RoleNames)) {
        this.roles.push({ id: role.id, name: role.name } as any)
      }
    }
    this.loadingRoles = false
  }

  showRoleSelection (flag: boolean) {
    if (flag) {
      this.searchRole = ''
      this.roleSelected = {}
      this.roleSelectionOpen = true
    } else {
      setTimeout(() => {
        this.roleSelectionOpen = false
        if (this.roleSelectedBackup.id) {
          this.selectRole(this.roleSelectedBackup)
        }
      }, 200)
    }
  }

  selectRole (role: any) {
    this.roleSelected = role
    this.roleSelectedBackup = role
    this.searchRole = role.name
  }

  isMatchRole (role: any) {
    if (!this.searchRole) return true
    const regexSearch = new RegExp(this.searchRole, 'i')
    return regexSearch.test(role.name)
  }

  /**
   * Configurations for a page request to get the group records
   *
   * @returns a PageRequest<GroupCatalogFilters>
   */
  prepareGroupRequest (domainId: number) {
    let pageRequest = new PageRequest<GroupCatalogFilters>()
    pageRequest.sort = 'name'
    // Only when the user is root is require all the groups in the domain
    if (userInfoStore.inRootDomain()) {
      pageRequest.filters.domain = domainId
    }
    pageRequest.filters.status = GroupStatus.ACTIVE
    return pageRequest
  }

  /**
   * Gets the group records
   *
   * @param domainId from get groups
   */
  async loadGroupsByDomain (domainId: number) {
    let pageRequest = this.prepareGroupRequest(domainId)
    const response = await catalogsService.getGroups(pageRequest)
    if (response.total <= 0) {
      this.$bvToast.toast(
        'No existe ningún grupo en este dominio. Es necesario contar con al menos uno para relacionarlo con el usuario.',
        {
          'title': 'Dominio sin grupos',
          'solid': true,
          'variant': 'warning',
          'noAutoHide': true
        })
    }
    this.groups = response.results
  }

  onCountryCodeChange (countryCode: any) {
    const item = this.phoneCodes.find(it => it.value === countryCode)
    this.selectedCountryIso = item ? item.iso : ''
  }

  getGroupsSelected (groups: Group[]): BasicEntity[] {
    let groupsObjects: BasicEntity[] = []
    groups.forEach(it => {
      if (it._selected) groupsObjects.push(new BasicEntity(it.id, it.name))
      if (it.subGroups && it.subGroups.length) groupsObjects = groupsObjects.concat(this.getGroupsSelected(it.subGroups))
    })
    return groupsObjects
  }

  setGroupsSelected (groups: Group[], selectedIds: number[]) {
    groups.forEach(it => {
      if (selectedIds.indexOf(it.id) > -1) Vue.set(it, '_selected', true) // check a group that was selected
      else Vue.set(it, '_selected', false) // uncheck a group that wasn't selected
      if (it.subGroups && it.subGroups.length) this.setGroupsSelected(it.subGroups, selectedIds)
    })
  }

  /**
   * Get the current groups ids related to the user
   *
   * @returns an array of group ids
   */
  getGroupSelectedIds (): number[] {
    return this.form.groups
      .reduce(
        (arr: number[], group: BasicEntity) =>
          !arr.includes(group.id)
            ? arr.concat(group.id)
            : arr /* callback */,
        [] /* initialValue */
      )
  }

  /**
   * Update the current group related to the user when one of them was changed
   *
   * @param selected flag that indicates if the group was selected or not
   * @param group that was selected or not
   */
  updateGroupsSelected (selected: boolean, group: Group): void {
    // Current selected groups related to the user
    // this may have duplicated values
    const selectedIds = this.getGroupSelectedIds()
    let selectedIdsSet = new Set(selectedIds)
    // Add or remove the group id from the set
    if (selected) selectedIdsSet.add(group.id)
    else selectedIdsSet.delete(group.id)

    const uniqueSelectedIds = Array.from(selectedIdsSet)
    // Update the state of all the checkboxes in the tree of groups
    this.setGroupsSelected(this.groups, uniqueSelectedIds)
    // Set the groups selected as the groups of the user
    this.form.groups = this.getGroupsSelected(this.groups)
  }

  validateState (ref: any) {
    const thiz = this as any
    if (
      thiz.veeFields[ref] &&
      (thiz.veeFields[ref].dirty || thiz.veeFields[ref].validated)
    ) {
      return !thiz.veeErrors.has(ref)
    }
    return null
  }

  get validateClient () {
    return this.searchClient && this.searchClient.length > 0
  }

  /**
   * @returns true if the current form has groups selected, false otherwise
   */
  validatesGroups () {
    return this.form.groups && this.form.groups.length > 0
  }

  /**
   * Launchs a message to confirm is the user does need groups
   *
   * @returns a boolean promise
   */
  async userWithoutGroupConfirmation () : Promise<boolean> {
    let confirmation = await this.$bvModal.msgBoxConfirm(
      'El usuario que se intenta guardar no cuenta con un grupo relacionado. ¿Estás seguro de guardar los cambios?',
      {
        title: 'Guardar usuario',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Sí, guardar',
        cancelVariant: 'outline-secondary',
        cancelTitle: 'Cancelar',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        hideHeaderClose: false
      }
    )
    return confirmation as boolean
  }

  async onSubmit () {
    // Get the groups selected
    this.form.groups = this.getGroupsSelected(this.groups)
    if (!this.validatesGroups()) {
      let noGroupConfirmation = await this.userWithoutGroupConfirmation()
      if (!noGroupConfirmation) {
        return
      }
    }
    this.$validator.validateAll().then(result => {
      if (result) {
        if (!(this.domainSelected.id >= 0)) {
          document.getElementById('input-domain')!.focus()
          return false
        }

        if (!this.clientSelected.id) {
          document.getElementById('input-client')!.focus()
          return false
        }

        if (!this.roleSelected.id) {
          document.getElementById('input-role')!.focus()
          return false
        }

        this.form.domain = new BasicEntity(this.domainSelected.id, this.domainSelected.name)
        this.form.client = new BasicEntity(this.clientSelected.id, this.clientSelected.name)
        this.form.role = new BasicEntity(this.roleSelected.id, this.roleSelected.name)

        this.loading = true
        this.form.updateDate = new Date()
        catalogsService.saveUser(this.form).then((response: User) => {
          this.form.id = response.id
          this.$emit('saved', this.form)
        }).catch((error) => {
          messageService.error('Error al guardar el usuario', `${error.response!.data!.description} - ${error.response!.data!.message}`)
        }).finally(() => {
          this.loading = false
        })
      } else {
        messageService.error('Errores en el formulario', 'Revise los campos marcados con error', 4500)
      }
    })
  }

  inactiveUser () {
    this.$bvModal.msgBoxConfirm(`Una vez que el usuario se da de baja no es posible reactivarlo. ¿Desea continuar con la baja del usuario?`, {
      title: 'Confirmación',
      size: 'md',
      okVariant: 'danger',
      okTitle: 'Sí',
      cancelTitle: 'No',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
      .then(async (confirmed: boolean) => {
        if (confirmed) {
          await catalogsService.inactiveUser(this.id).then(() => {
            this.form.status = UserStatus.INACTIVE
            this.form.disableDate = new Date()
            this.$emit('saved', this.form)
          }).catch((error) => {
            messageService.error('Error al dar de baja el usuario', `${error.response!.data!.description} - ${error.response!.data!.message}`)
          })
        }
      })
  }

  resetPass () {
    this.$bvModal.msgBoxConfirm(`¿Desea aplicar un reseteo de password para el usuario?`, {
      title: 'Confirmación',
      size: 'md',
      okVariant: 'danger',
      okTitle: 'Sí',
      cancelTitle: 'No',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
    })
      .then(async (confirmed: boolean) => {
        if (confirmed) {
          catalogsService.resetUserPassword(this.id).then(() => {
            this.form.status = UserStatus.UPDATE_PASSWORD
            this.form.updateDate = new Date()
            this.$emit('saved', this.form)
          }).catch((error) => {
            messageService.error('Error al actualizar el usuario', `${error.response!.data!.description} - ${error.response!.data!.message}`)
          })
        }
      })
  }

  onEdit () {
    this.$emit('edit')
  }

  onCancel () {
    this.$emit('close')
  }
}
</script>

<style>
.users-admin-form .country-flag {
  position: absolute;
  top: 32px;
  right: 72px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.users-admin-form .users-groups .group-root input[type=checkbox] {
  visibility: hidden;
}
</style>
